import React, { useContext } from 'react';
import AppLink from '../links/AppLink';
import clsx from 'clsx';
import styles from './SubNav.module.less';
import RequestContext from '../../services/RequestContext';
import { Dicon } from 'edcom-ui';
import Hamburger from './Hamburger';
import Dropdown from './Dropdown';
import PropTypes from 'prop-types';
import style from './SubNav.module.less';

export default function SubNav({ open = false, onClick, page }) {
  const subNavClasses = clsx(style.subNavMore, open && 'open');
  const { query } = useContext(RequestContext);
  let tsNow = Date.now();
  let seasonalLink =
    (tsNow > Math.round(new Date('2021/08/23 00:00:00').getTime()) &&
      tsNow < Math.round(new Date('2021/09/18 00:00:00').getTime())) ||
    query['seasonal-menu'];
  let artContest =
    tsNow > Math.round(new Date('2022/09/17 00:00:00').getTime()) &&
    tsNow < Math.round(new Date('2022/10/10 00:00:00').getTime());
  let daysOfHalloween =
    tsNow > Math.round(new Date('2022/10/18 00:00:00').getTime()) &&
    tsNow < Math.round(new Date('2022/11/01 00:00:00').getTime());
  let readingMonth =
    tsNow > Math.round(new Date('2023/03/01 00:00:00').getTime()) &&
    tsNow < Math.round(new Date('2023/04/01 00:00:00').getTime());
  let mathMonth =
    tsNow > Math.round(new Date('2023/04/02 00:00:00').getTime()) &&
    tsNow < Math.round(new Date('2023/05/01 00:00:00').getTime());
  let summerBoost =
    tsNow > Math.round(new Date('2022/05/29 00:00:00').getTime()) &&
    tsNow < Math.round(new Date('2022/08/15 00:00:00').getTime());
  return (
    <nav className={style.subNav}>
      <div className={style.container}>
        <div className={subNavClasses}>
          <Hamburger onClick={onClick} desktopOnly={true} />
          <Dropdown open={open} page={page} />
          <div className={style.subNavLinks}>
            <ul>
              <li>
                <AppLink data-cid="11.2143" href="/worksheets/">
                  Worksheets
                </AppLink>
              </li>
              <li>
                <AppLink data-cid="11.2143" href="/games/">
                  Games
                </AppLink>
              </li>
              <li>
                <AppLink data-cid="11.2143" href="/lesson-plans/">
                  Lesson plans
                </AppLink>
              </li>
              <li>
                <AppLink data-cid="11.2143" href="/activity/">
                  Activities
                </AppLink>
              </li>
              <li>
                <AppLink data-cid="11.2143" href="/workbooks/">
                  Workbooks
                </AppLink>
              </li>
              <li>
                <AppLink data-cid="11.2143" href="/exercises/">
                  Exercises
                </AppLink>
              </li>
              <li>
                <AppLink data-cid="11.2143" href="/songs/">
                  Songs
                </AppLink>
              </li>
              <li>
                <AppLink data-cid="11.2143" href="/stories/">
                  Stories
                </AppLink>
              </li>
              {seasonalLink && (
                <li className={clsx(styles.mobileOnly, styles.summer)}>
                  <AppLink href="/back-to-school/" className={styles.text}>
                    <Dicon name="back-to-school" theme="red" />
                    Back to School
                  </AppLink>
                </li>
              )}
              {artContest && (
                <li>
                  <AppLink
                    href="/art-contest/"
                    className={styles.artcontestlink}
                  >
                    <img
                      className={styles.artcontesticon}
                      src="https://cdn.education.com/files/static/art-contest/halloween-top-nav.png"
                      alt="art contest"
                    />
                    <div className={styles.artcontesttext}>Art Contest</div>
                  </AppLink>
                </li>
              )}
              {daysOfHalloween && (
                <li className={clsx(styles.mobileOnly, styles.daysofhalloween)}>
                  <AppLink href="/halloween/" className={styles.text}>
                    <Dicon name="halloween" />
                    Halloween
                  </AppLink>
                </li>
              )}
              {readingMonth && (
                <li className={clsx(styles.mobileOnly, styles.readingMonth)}>
                  <AppLink href="/reading-month/" className={styles.text}>
                    <Dicon name="reading" theme="dark" />
                    Reading Month
                  </AppLink>
                </li>
              )}
              {mathMonth && (
                <li className={clsx(styles.mobileOnly, styles.readingMonth)}>
                  <AppLink href="/math-month/" className={styles.text}>
                    <Dicon name="math" theme="dark" />
                    Math Month
                  </AppLink>
                </li>
              )}
              {summerBoost && (
                <li className={clsx(styles.mobileOnly, styles.readingMonth)}>
                  <AppLink href="/summer-boost/" className={styles.text}>
                    <Dicon name="summer-boost" theme="yellow" />
                    Summer Boost
                  </AppLink>
                </li>
              )}
            </ul>
          </div>
        </div>
      </div>
    </nav>
  );
}

SubNav.propTypes = {
  open: PropTypes.bool,
  onClick: PropTypes.func,
  page: PropTypes.string,
};
